import React from 'react';
import { Close as CloseIcon, ArrowBack as BackIcon } from '@mui/icons-material';
import Dialog from '@mui/material/Dialog';
import Text from '../Text.js';
import Button from '../Button.js';
import { colors } from '../../theme/index.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 *
 * @param {*} param0
 */
const FormModal = ({
  open,
  close,
  title,
  maxWidth,
  fullWidth,
  transitionComponent,
  children,
  disableBackdropClick = false,
  disableEscapeKeyDown,
  onSave,
  onBack,
  saveButtonText,
  showSaveButton = true,
  onRemove,
  onReset,
  resetButtonText,
  customContainerStyle,
  customFormStyle,
  customTitleIconWrapperStyle,
  noHeader,
  testid,
  id,
  saveButtonStyle,
  secondaryButtonStyle,
  removeButtonText
}) => {
  const styles = {
    form: {
      flex: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 0,
      paddingTop: 0,
      overflowY: 'auto',
      borderRadius: '16px'
    },
    modal: {
      overflow: 'auto',
      outline: 'none',
      padding: '40px',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      backgroundColor: colors.surface,
      height: '100%',
      maxWidth: fullWidth ? null : '850px'
    },
    modalTopRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeModalIcon: {
      cursor: 'pointer',
      fontSize: '22px'
    },
    goBackIcon: {
      cursor: 'pointer',
      fontSize: '22px',
      marginRight: 1.25,
      lineHeight: 20
    },
    titleIconWrapper: {
      width: '100%',
      paddingBottom: '15px',
      color: colors.mainTextGrey,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    maxWidth: maxWidth,
    fullWidth: fullWidth,
    onClose: disableBackdropClick ? null : () => close(),
    open: open,
    "aria-labelledby": title,
    TransitionComponent: transitionComponent,
    disableEscapeKeyDown: disableEscapeKeyDown,
    sx: {
      "& .MuiPaper-rounded": {
        borderRadius: "8px"
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.modal,
      ...customContainerStyle
    }
  }, noHeader ? null : /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.titleIconWrapper,
      ...customTitleIconWrapperStyle
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, onBack && /*#__PURE__*/React.createElement(BackIcon, {
    sx: styles.goBackIcon,
    onClick: onBack
  }), /*#__PURE__*/React.createElement(Text, {
    id: id || testid,
    align: "center",
    bold: true,
    large: true,
    display: "inline-block",
    margin: "0"
  }, title)), close && /*#__PURE__*/React.createElement(CloseIcon, {
    sx: styles.closeModalIcon,
    onClick: close
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.form,
      ...customFormStyle
    }
  }, children), onReset && onSave && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 1,
      width: 'calc(100%)',
      backgroundColor: '#D1D3D4'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '0 40px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onReset,
    transparent: true,
    marginTop: 2.5,
    customStyle: {
      width: '48%',
      fontSize: '17px',
      ...secondaryButtonStyle
    }
  }, resetButtonText || i18n.t(tokens.buttons.reset)), showSaveButton && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: onSave,
    marginTop: 2.5,
    customStyle: {
      width: '48%',
      fontSize: '17px',
      ...saveButtonStyle
    }
  }, saveButtonText || i18n.t(tokens.buttons.save)))), onRemove && onSave && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onRemove,
    transparent: true,
    marginTop: 3,
    sx: {
      '&:hover': {
        backgroundColor: "lightGrey"
      }
    },
    customStyle: {
      ...secondaryButtonStyle
    }
  }, removeButtonText || i18n.t(tokens.buttons.remove)), showSaveButton && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: onSave,
    marginTop: 3,
    customStyle: {
      ...saveButtonStyle
    }
  }, saveButtonText || i18n.t(tokens.buttons.save))), !onReset && !onRemove && onSave && /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: 20,
      marginLeft: 20
    }
  }, showSaveButton && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    fullWidth: true,
    onClick: onSave,
    marginTop: 3,
    customStyle: {
      ...saveButtonStyle
    }
  }, saveButtonText || i18n.t(tokens.buttons.save)))));
};
export default FormModal;